import { render, staticRenderFns } from "./PayBills.vue?vue&type=template&id=fdf2b872&"
import script from "./PayBills.vue?vue&type=script&lang=js&"
export * from "./PayBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports